import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConnectRestService } from 'src/app/services/connect-rest.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EnglishTranslation, MalayTranslation, ProductCode } from '../app.constants';
import { DataStoreService } from '../data-store.service';

declare var $: any ;

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit, AfterViewInit {
  product:string = '';
  productDescription: any;
  showProductDescription: string='';
  getLocStore:any; 
  getFromLocStorage: boolean;
  saveQueryParams: any;
  islamicBanking: boolean = false;
  textContent: any = EnglishTranslation.StartScreen;
  FAQLink: string = 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/EN_eBiz_Account_Opening_FAQ.pdf'
  constructor(
    private connect : ConnectRestService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dataStoreService: DataStoreService
  ) { 
    this.connect.clearSessionStorage();
    //(Begin) CW listen for product param -----
    this.activatedRoute.queryParams.subscribe(params => {
      if(!params['lang']) {
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {
            lang: 'en-us'
          },
          queryParamsHandling: 'merge',
          skipLocationChange: false
        });
      } 

      // check if existing product code is the same 
      if (this.product !== params['product']) {
        this.product = params['product'] ? params['product'] : ProductCode.eBiz;
        this.getProdDesc(this.product, params);
      }
      
      if(params['lang'] && params['lang'] == 'ms') {
        this.textContent = MalayTranslation.StartScreen;
      } else {
        this.textContent = EnglishTranslation.StartScreen;
      }

      if (params['product'] == ProductCode.eBizi) {
        this.islamicBanking = true;
        if(params['lang'] && params['lang'] == 'ms') {
          this.FAQLink = 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/BM_eBiz-i_Account_Opening_FAQ.pdf'
        } else {
          this.FAQLink = 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz-i/ENG_eBiz-i_Account_Opening_FAQ.pdf';
        }
      } else if(params['product'] == ProductCode.Access || params['product'] == ProductCode.Signature) {
        this.islamicBanking = false;
        this.FAQLink = 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/business%20account/OCBC_BusinessAccount_FAQ_%28EN%29.pdf';
      } else {
        this.islamicBanking = false;
        if(params['lang'] && params['lang'] == 'ms') {
          this.FAQLink = 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/BM_eBiz_Account_Opening_FAQ.pdf'
        } else {
          this.FAQLink = 'https://www.ocbc.com.my/iwov-resources/my/ocbc/business/pdf/smes/accounts/ebiz/EN_eBiz_Account_Opening_FAQ.pdf';
        }
      }     
      
      this.showProductDescription = this.productDescription && this.productDescription[params['lang']] ? this.productDescription[params['lang']] : '';
      this.saveQueryParams = params;
    })
    //(End) CW 23Apr2021
  }

  ngOnInit() {
    sessionStorage.setItem("contactInfo", "true");
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      this.dataStoreService.setAAData('start');
    }
  }

  async getProdDesc(pcode, params) {
    const RequestID = 'R0320';
    var serviceBody = {
      'ProductCode': pcode
    };
    
    const responseData:any = await this.connect.connectRest(serviceBody, RequestID, '');
    if (responseData.Status === 'Success') {
        this.productDescription = { 
          'ms' : responseData.ProductDescriptionMY,
          'en-us' : responseData.ProductDescriptionEN
        }

        var lang = params['lang'] ? params['lang'] : 'en-us'
        this.showProductDescription = this.productDescription[lang]; 
        this.getLocStore = {"Product": this.product,"ProductDescription": this.showProductDescription, "Source1":params['source1'],"Source2":params['source2']}
        localStorage.setItem('URLParam', JSON.stringify(this.getLocStore));
        sessionStorage.setItem('ProductDescription', this.showProductDescription);
        sessionStorage.setItem("currentProduct", this.product);
    } 
  }

  onStartClick() {
    this.saveToStorage();
    this.router.navigate(['/tell-us']);
  }

  appointmentClick() {
    this.saveToStorage();
  }

  getQueryParams() {
    return { ...this.saveQueryParams, productDescription: this.showProductDescription};
  }

  saveToStorage() {
    localStorage.setItem('SavedQueryParams', JSON.stringify(this.saveQueryParams));
    this.getLocStore['ProductDescription'] = this.showProductDescription;
    localStorage.setItem('URLParam', JSON.stringify(this.getLocStore));
    var product = this.saveQueryParams['product'] ? this.saveQueryParams['product'] : ProductCode.eBiz;
    sessionStorage.setItem("currentProduct", product);
    var lang = this.saveQueryParams['lang'] ? this.saveQueryParams['lang'] : 'en-us';
    sessionStorage.setItem("language", lang);
  }

  getLink() {
    return this.saveQueryParams['lang'] && this.saveQueryParams['lang'] !== "ms" ? "https://www.ocbc.com.my/business-banking/smes/accounts/ebiz" : "https://www.ocbc.com.my/business-banking/bm/smes/accounts/ebiz";
  }
}
